(function () {
  if (!document.body.classList.contains('home-cinema')) return;

  var hero = document.querySelector('[data-home-cinema]');
  var ticker = document.querySelector('.home-ticker');
  if (!hero) return;

  function syncTickerHeight() {
    var height = ticker ? ticker.offsetHeight : 0;
    document.documentElement.style.setProperty('--home-ticker-height', height + 'px');
  }

  function initBgVideo() {
    var bgVideo = hero.querySelector('[data-home-cinema-bg-video]');
    if (!bgVideo) return;

    bgVideo.muted = true;
    bgVideo.defaultMuted = true;
    bgVideo.setAttribute('muted', '');
    bgVideo.setAttribute('playsinline', '');
    bgVideo.setAttribute('webkit-playsinline', '');

    function tryPlay() {
      var playPromise = bgVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    tryPlay();
    bgVideo.addEventListener('loadeddata', tryPlay, { once: true });
    bgVideo.addEventListener('canplay', tryPlay, { once: true });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tryPlay();
    });
    window.addEventListener('pageshow', tryPlay);
    document.addEventListener('touchstart', tryPlay, { once: true, passive: true });
  }

  function initIntroSequence() {
    if (!hero.classList.contains('is-intro-pending')) return;

    var steps = Array.prototype.slice.call(hero.querySelectorAll('[data-intro-step]'));
    steps.sort(function (a, b) {
      return parseInt(a.getAttribute('data-intro-step'), 10) - parseInt(b.getAttribute('data-intro-step'), 10);
    });
    if (!steps.length) {
      hero.classList.remove('is-intro-pending');
      hero.classList.add('is-intro-done');
      return;
    }

    var stepDurationSec = parseFloat(hero.getAttribute('data-intro-step-duration') || '1.4');
    var stepMs = Math.max(800, Math.min(stepDurationSec * 1000, 2500));
    var current = 0;
    var timers = [];

    function clearTimers() {
      timers.forEach(function (id) {
        window.clearTimeout(id);
      });
      timers = [];
    }

    function finishIntro() {
      clearTimers();
      hero.classList.remove('is-intro-pending');
      for (var i = 1; i <= 6; i += 1) {
        hero.classList.remove('is-intro-step-' + i);
      }
      hero.classList.add('is-intro-done');
    }

    function showStep(index) {
      for (var i = 1; i <= 6; i += 1) {
        hero.classList.remove('is-intro-step-' + i);
      }
      var step = steps[index];
      if (!step) {
        finishIntro();
        return;
      }
      var stepNum = parseInt(step.getAttribute('data-intro-step'), 10);
      hero.classList.add('is-intro-step-' + stepNum);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishIntro();
      return;
    }

    showStep(0);

    function scheduleNext() {
      current += 1;
      if (current >= steps.length) {
        timers.push(window.setTimeout(finishIntro, stepMs));
        return;
      }
      showStep(current);
      timers.push(window.setTimeout(scheduleNext, stepMs));
    }

    timers.push(window.setTimeout(scheduleNext, stepMs));
  }

  initBgVideo();
  initIntroSequence();
  syncTickerHeight();

  window.addEventListener('resize', syncTickerHeight, { passive: true });
})();
